// extracted by mini-css-extract-plugin
export default {"buttonClose":"ButtonClose_buttonClose__UDBOi","buttonCloseIcon":"ButtonClose_buttonCloseIcon__48eb1","buttonCloseIconWhite":"ButtonClose_buttonCloseIconWhite__3IrhG"};